import {
  MAX_CLOUD_IMAGE_SIZE,
  MAX_UPLOAD_LOGO_SIZE,
  ProcessTypes,
  SCENE7_TEMPLATE_BASIC_URL_BACKGROUND,
  SCENE7_TEMPLATE_BASIC_URL_HOTSTAMPED,
  SCENE7_TEMPLATE_BASIC_URL_UPLOAD,
  digitalTemplateType,
  logoEditingStatusEnum,
  logoLayoutOption,
  nucleusHostName,
  rotateDirectionEnum,
  scene7StockImageMode,
  userImageType,
} from './constants';
import { Scene7_Template_Prefix, VIGNETTE_SCALE_PLACE_HOLDER, VIGNETTE_SIZE_PLACE_HOLDER } from '../nextgen/constants';

import { get } from './request';
import { studioItemType as studioItemTypeEnum } from '../main/constants';

const PLACEHOLDER_SCENE7FILENAME = '{Scene7FileName}';
const PLACEHOLDER_FOLDERID = '{FolderId}';
const PLACEHOLDER_DESIGNID = '{DesignId}';
const PLACEHOLDER_WIDTH = '{Width}';
const PLACEHOLDER_HEIGHT = '{Height}';
const PREVIEW_MAX_DIMENSION = 500;
const PLACEHOLDER_COLORCODE = '{ColorCode}';
const PLACEHOLDER_ITEMID = '{ItemId}';
const PLACEHOLDER_CODE = '{Code}';
const PLACEHOLDER_CODEVALUE = '{CodeValue}';
const PLACEHOLDER_HOTSTAMPED_SRC = '{hotstampedSrc}';
const PLACEHOLDER_MASK_SRC = '{maskSrc}';
const TEXTURE_IMAGE = '{TextureImage}';
const COLORIZED_STOCKIMAGE_URL =
  '//images.promotionalstore.com/is/image/PromotionalStore/i?src=is{PromotionalStore/product_{ItemId}_c_{CodeValue}}';
const TEXTURIZED_STOCKIMAGE_URL =
  '//images.promotionalstore.com/is/image/PromotionalStore/i?src=is{PromotionalStore/{TextureImage}}';

export function getPreviewDimension(originalWidth, originalHeight) {
  let previewDimension = { width: originalWidth, height: originalHeight };
  if (originalWidth > PREVIEW_MAX_DIMENSION || originalHeight > PREVIEW_MAX_DIMENSION) {
    if (originalWidth > originalHeight) {
      previewDimension.width = PREVIEW_MAX_DIMENSION;
      previewDimension.height = (Number(originalHeight) / originalWidth) * PREVIEW_MAX_DIMENSION;
    } else {
      previewDimension.height = PREVIEW_MAX_DIMENSION;
      previewDimension.width = (Number(originalWidth) / originalHeight) * PREVIEW_MAX_DIMENSION;
    }
  }
  return previewDimension;
}

/**
 * get digital common template thumbnail url
 * @param {int} designId - designId of template
 */
export function getTemplateThumbnailUrl(designId) {
  return '//images.promotionalstore.com/is/image/PromotionalStore/i?src=is{PromotionalStore/digital_thumb_{DesignId}}'.replace(
    '{DesignId}',
    designId
  );
}

export function getTemplatePreviewUrl(templatePreview, template, width) {
  const designIdPlaceHolder = templatePreview.placeHolder.designIdPlaceHolder;
  const folderIdPlaceHolder = templatePreview.placeHolder.designIdPlaceHolder;
  const leftPlaceHolder = templatePreview.placeHolder.leftPlaceHolder;
  const rightPlaceHolder = templatePreview.placeHolder.rightPlaceHolder;
  let url = '';
  let designIdWholePlaceHolder = leftPlaceHolder + designIdPlaceHolder + rightPlaceHolder;
  let folderIdWholePlaceHolder = leftPlaceHolder + folderIdPlaceHolder + rightPlaceHolder;
  url = templatePreview.url
    .replace(designIdWholePlaceHolder, template.designId)
    .replace(folderIdWholePlaceHolder, template.folderId);
  url += '&' + width;
  return url;
}

/**
 * get stock/slogan/shared/verse/sentiment thumbnail preview for list
 * @param {string} scene7FileName - scene7 file name
 * @param {Enumerator} type -  userImageType in constants.js
 */
export function getArtThumbnailUrl(scene7FileName, type) {
  let url =
    '//images.promotionalstore.com/is/image/PromotionalStore/i?src=is{PromotionalStore/{Scene7FileName}}&{ImagePreset}'.replace(
      '{Scene7FileName}',
      scene7FileName
    );
  switch (type) {
    case userImageType.StockArt:
    case userImageType.Slogan:
      url = url.replace('{ImagePreset}', '$Studio_StockT$');
      break;
    case userImageType.Verse:
    case userImageType.Sentiment:
      url = url.replace('{ImagePreset}', '$Studio_VerseT$');
      break;
    case userImageType.SharedArt:
      url = url.replace('{ImagePreset}', '$Studio_SharedT$');
      break;
    default:
      break;
  }
  return url;
}

const COMMONTEMPLATE_CANVASURL =
  'https://images.promotionalstore.com/is/image/PromotionalStore/i?src=is{PromotionalStore/digital_design_{FolderId}_{DesignId}?size={Width},{Height}}&fmt=png-alpha&wid={Width}&hei={Height}';

/**
 *
 * @param {*} selectedTemplate
 * @param {*} containerSize
 */
export function getTemplateCanvasUrl(template, containerSize, itemUseScene7Template, vignetteImageInfo, backColor) {
  let url = '';
  switch (template.templateType) {
    case digitalTemplateType.Common:
    case digitalTemplateType.Default:
      url = COMMONTEMPLATE_CANVASURL.replace(PLACEHOLDER_DESIGNID, template.designId)
        .replace(PLACEHOLDER_FOLDERID, template.folderId)
        .replace(PLACEHOLDER_WIDTH, containerSize.width)
        .replace(PLACEHOLDER_WIDTH, containerSize.width)
        .replace(PLACEHOLDER_HEIGHT, containerSize.height)
        .replace(PLACEHOLDER_HEIGHT, containerSize.height);
      break;
    case digitalTemplateType.Custom:
      url = getCustomBackgroundUrl(template, containerSize, itemUseScene7Template, vignetteImageInfo, backColor);
      break;
    case digitalTemplateType.Blank:
      url = COMMONTEMPLATE_CANVASURL.replace(PLACEHOLDER_DESIGNID, 'template')
        .replace(PLACEHOLDER_FOLDERID, 'blank')
        .replace(PLACEHOLDER_WIDTH, containerSize.width)
        .replace(PLACEHOLDER_WIDTH, containerSize.width)
        .replace(PLACEHOLDER_HEIGHT, containerSize.height)
        .replace(PLACEHOLDER_HEIGHT, containerSize.height);
      break;
    default:
      break;
  }
  return url;
}

const ART_URL = `${
  nucleusHostName[process.env.REACT_APP_BUILD_ENV]
}/api/v1/entity/Promo/content/{Scene7FileName}/image?`;

export function getTempBackgroundUrl({
  image,
  containerSize,
  itemUseScene7Template,
  vignetteImageInfo,
  backColor,
  isInRecent,
}) {
  let url;
  if (itemUseScene7Template) {
    url = getUrlBase({ image, containerSize, isBackground: true, vignetteImageInfo, backColor, isInRecent }).url;
  } else {
    url = ART_URL.replace(PLACEHOLDER_SCENE7FILENAME, image.scene7FileName);

    if (!image.cropRect) {
      let previewDimension = getPreviewDimension(image.originalWidth, image.originalHeight);
      if (previewDimension.width > 0) url += '&wid=' + previewDimension.width;
    }
  }
  return url;
}

function getUrlBase({ image, containerSize, isBackground, vignetteImageInfo, backColor, isInRecent }) {
  let url = isBackground ? SCENE7_TEMPLATE_BASIC_URL_BACKGROUND : SCENE7_TEMPLATE_BASIC_URL_UPLOAD;

  if (isBackground) url += '&size=' + containerSize.width + ',' + containerSize.height;
  const canvasSize = { width: containerSize.width, height: containerSize.height };
  const imageSize = { width: image.originalWidth, height: image.originalHeight };

  const newImageSize = backgroundRotate(canvasSize, imageSize, image.direction);

  if (isBackground) {
    url += vignetteImageInfo
      ? getNextgenBackgroundUrl(vignetteImageInfo, containerSize, imageSize, image.scene7FileName, isInRecent)
      : backColor
      ? getColorBackgroundUrl(backColor, containerSize, imageSize, image.scene7FileName)
      : '&layer=1&src=is{' + image.scene7FileName + '?size=' + imageSize.width + ',' + imageSize.height + '}';
  } else url += '&src=is{' + image.scene7FileName + '?size=' + imageSize.width + ',' + imageSize.height + '}';

  let cropRect, result;
  cropRect = {
    x: image.autoCropRect.x + image.cropRect.x,
    y: image.autoCropRect.y + image.cropRect.y,
    width: image.cropRect.width,
    height: image.cropRect.height,
  };

  const hasCrop = !(
    (cropRect.x === 0 &&
      cropRect.y === 0 &&
      cropRect.width === image.originalWidth &&
      cropRect.height === image.originalHeight) ||
    (cropRect.width === 0 && cropRect.height === 0)
  );
  let pos = { x: 0, y: 0 },
    size;
  if (image.direction && hasCrop) {
    result = backgroundCropRotate(canvasSize, imageSize, cropRect, image.direction);
    size = result.size;
    pos = result.position;
    url +=
      '&crop=' +
      Math.round(cropRect.x) +
      ',' +
      Math.round(cropRect.y) +
      ',' +
      Math.round(cropRect.width) +
      ',' +
      Math.round(cropRect.height);
    url += '&rotate=' + image.direction;
  } else if (image.direction && !hasCrop) {
    size = newImageSize;
    url += '&size=' + Math.round(newImageSize.width) + ',' + Math.round(newImageSize.height);
    url += '&rotate=' + image.direction;
  } else if (!image.direction && hasCrop) {
    result = isBackground ? backgroundCrop(canvasSize, imageSize, cropRect) : crop(canvasSize, imageSize, cropRect);
    if (isBackground) {
      size = result.size;
      pos = result.position;
    } else {
      size = { width: result.width, height: result.height };
      pos = { x: result.x, y: result.y };
    }
    url +=
      '&crop=' +
      Math.round(cropRect.x) +
      ',' +
      Math.round(cropRect.y) +
      ',' +
      Math.round(cropRect.width) +
      ',' +
      Math.round(cropRect.height);
  } else {
    size = adjustImageSizeToFitContainer(imageSize, canvasSize);
  }

  // process background fill
  if (isBackground) {
    const offsetX = (image.croppedFill.left - image.croppedFill.right) / 2;
    const offsetY = (image.croppedFill.top - image.croppedFill.bottom) / 2;
    if (offsetX !== 0 || offsetY !== 0) {
      const cropSize = { width: cropRect.width, height: cropRect.height };
      const { scale } = rotate(canvasSize, cropSize, image.direction);
      if (image.direction === 0) {
        if (offsetX !== 0) pos.x += offsetX * scale;
        if (offsetY !== 0) pos.y += offsetY * scale;
      } else if (image.direction === 90) {
        if (offsetX !== 0) pos.y += offsetX * scale;
        if (offsetY !== 0) pos.x += offsetY * scale * -1;
      } else if (image.direction === 180) {
        if (offsetX !== 0) pos.x += offsetX * scale * -1;
        if (offsetY !== 0) pos.y += offsetY * scale * -1;
      } else if (image.direction === 270) {
        if (offsetX !== 0) pos.y += offsetX * scale * -1;
        if (offsetY !== 0) pos.x += offsetY * scale;
      }
    }
  }

  if (size) url += '&size=' + Math.round(size.width) + ',' + Math.round(size.height);
  if (pos.x !== 0 || pos.y !== 0) url += '&pos=' + Math.round(pos.x) + ',' + Math.round(pos.y);

  return { url, pos, size, cropRect };
}

const getNextgenBackgroundUrl = (vignetteImageInfo, containerSize, imageSize, scene7FileName, isInRecent) => {
  if (!vignetteImageInfo || !vignetteImageInfo.imageUrl) return '';

  const index = vignetteImageInfo.imageUrl.indexOf(Scene7_Template_Prefix);
  let templateUrl = vignetteImageInfo.imageUrl.substring(index + Scene7_Template_Prefix.length);

  if (templateUrl.indexOf(VIGNETTE_SCALE_PLACE_HOLDER) > -1) {
    const scaleX = vignetteImageInfo.imageSize.width / vignetteImageInfo.canvasSize.width;
    const scaleY = vignetteImageInfo.imageSize.height / vignetteImageInfo.canvasSize.height;
    const regex = new RegExp(VIGNETTE_SCALE_PLACE_HOLDER, 'g');
    templateUrl = templateUrl.replace(regex, 'scale=' + Math.max(scaleX.toFixed(4), scaleY.toFixed(4)));
    const newSize = {
      width: containerSize.width * scaleX,
      height: containerSize.height * scaleY,
    };
    templateUrl += '&size=' + newSize.width.toFixed(2) + ',' + newSize.height.toFixed(2);
    const pos = {
      x: (newSize.width - containerSize.width) / 2,
      y: (newSize.height - containerSize.height) / 2,
    };
    pos.x += (vignetteImageInfo.offset.x / vignetteImageInfo.imageSize.width) * newSize.width * -1;
    pos.y += (vignetteImageInfo.offset.y / vignetteImageInfo.imageSize.height) * newSize.height * -1;

    templateUrl += '&pos=' + pos.x.toFixed(2) + ',' + pos.y.toFixed(2);
  }
  let url = '';
  if (!isInRecent) url += '&layer=1' + (templateUrl[0] === '&' ? templateUrl : '&' + templateUrl);
  url += '&layer=2&src=is{' + scene7FileName + '?size=' + imageSize.width + ',' + imageSize.height + '}';
  return url;
};

const getColorBackgroundUrl = (backColor, containerSize, imageSize, scene7FileName) => {
  let url =
    '&layer=1&size=' + containerSize.width + ',' + containerSize.height + '&color=' + backColor.replace('#', '');
  url += '&layer=2&src=is{' + scene7FileName + '?size=' + imageSize.width + ',' + imageSize.height + '}';
  return url;
};

export function getUrlForRotatePreviewPanel(
  image,
  containerSize,
  itemUseScene7Template,
  studioItemType,
  maxColorCount,
  processType,
  showImageSingleColor
) {
  let url;
  const imageSize = { width: image.width, height: image.height };

  if (itemUseScene7Template) {
    url = addColorizeParamToUrl(
      getUrlBase({ image, containerSize, isBackground: false }).url,
      studioItemType,
      maxColorCount,
      image.colors,
      false,
      processType
    );
  } else {
    url = ART_URL.replace(PLACEHOLDER_SCENE7FILENAME, image.scene7FileName);
  }

  if (!itemUseScene7Template) {
    const displayWidth = adjustImageSizeToFitContainer(imageSize, containerSize).width;
    url += '&wid=' + displayWidth;
  }

  if (showImageSingleColor) {
    const colorReference = image.colors && image.colors[0] && image.colors[0].colorReference;
    if (colorReference) url += '&op_contrast=-100&op_brightness=-100&op_colorize=' + colorReference.replace('#', '');
  }
  return url;
}

export function addUrlParamForLogoCropPanel(
  originImageUrl,
  image,
  itemUseScene7Template,
  currentStatus,
  isHotStamped,
  containerWidthHeight
) {
  let url;
  if (itemUseScene7Template) {
    if (currentStatus === logoEditingStatusEnum.LogoCropping) {
      url = originImageUrl + '&rotate=' + image.direction;
    } else {
      url = isHotStamped
        ? addUrlParamForHotStamp(originImageUrl, image, {
            width: containerWidthHeight,
            height: containerWidthHeight,
          })
        : originImageUrl;
    }
  } else {
    url = originImageUrl;
    if (image.direction) {
      url += '&rotate=' + image.direction;
      if (image.direction === rotateDirectionEnum.degrees90 || image.direction === rotateDirectionEnum.degrees270)
        url += '&wid=' + image.originalHeight;
      else url += '&wid=' + image.originalWidth;
    } else url += '&wid=' + image.originalWidth;
  }
  return url;
}

export function getScene7Url(scene7FileName, imageOriginalSize, width, itemUseScene7Template) {
  if (!scene7FileName) return null;

  let url;
  if (itemUseScene7Template) {
    url = SCENE7_TEMPLATE_BASIC_URL_UPLOAD;
    url += '&size=' + imageOriginalSize.width + ',' + imageOriginalSize.height;
    url += '&src=is{' + scene7FileName + '?size=' + imageOriginalSize.width + ',' + imageOriginalSize.height + '}';
    url += '&wid=' + imageOriginalSize.width;
  } else {
    url = ART_URL.replace(PLACEHOLDER_SCENE7FILENAME, scene7FileName);
  }
  if (width) url += '&wid=' + width;
  else if (imageOriginalSize.width > MAX_UPLOAD_LOGO_SIZE) url += '&wid=' + MAX_UPLOAD_LOGO_SIZE;

  return url;
}

export function getCustomBackgroundUrl(imageData, containerSize, itemUseScene7Template, vignetteImageInfo, backColor) {
  let url;
  if (itemUseScene7Template) {
    url = getUrlBase({ image: imageData, containerSize, isBackground: true, vignetteImageInfo, backColor }).url;
  } else {
    url = ART_URL.replace(PLACEHOLDER_SCENE7FILENAME, imageData.scene7FileName);

    if (imageData.cropRect && imageData.cropRect.width > 0 && imageData.cropRect.height > 0) {
      const cropRect = adjustCropSize(
        { width: imageData.originalWidth, height: imageData.originalHeight },
        imageData.cropRect,
        itemUseScene7Template
      );
      url += '&crop=' + cropRect.x + ',' + cropRect.y + ',' + cropRect.width + ',' + cropRect.height;
    }

    if (imageData.direction) {
      url += '&rotate=' + imageData.direction;
    }

    if (imageData.croppedFill) {
      const scale = getImageScale({ width: imageData.originalWidth, height: imageData.originalHeight });
      let fills;

      const croppedFill = imageData.croppedFill;
      const fillLeft = croppedFill.left / scale;
      const fillTop = croppedFill.top / scale;
      const fillRight = croppedFill.right / scale;
      const fillBottom = croppedFill.bottom / scale;

      if (imageData.direction === 0) fills = [fillLeft, fillTop, fillRight, fillBottom];
      else if (imageData.direction === 90) fills = [fillBottom, fillLeft, fillTop, fillRight];
      else if (imageData.direction === 180) fills = [fillRight, fillBottom, fillLeft, fillTop];
      else if (imageData.direction === 270) fills = [fillTop, fillRight, fillBottom, fillLeft];
      url += '&op_extend=' + fills[0] + ',' + fills[1] + ',' + fills[2] + ',' + fills[3];
    }
  }
  if (containerSize.width && !itemUseScene7Template) {
    url += '&wid=' + containerSize.width;
  }

  return url;
}

export function getLogoImprintViewUrl(imageData) {
  let previewDimension = getPreviewDimension(imageData.originalWidth, imageData.originalHeight);
  previewDimension.width = Math.round(previewDimension.width);
  previewDimension.height = Math.round(previewDimension.height);
  let url;
  if (imageData.itemUseScene7Template) {
    url = getUrlBase({ image: imageData, containerSize: previewDimension, isBackground: false }).url;
  } else {
    url = ART_URL.replace(PLACEHOLDER_SCENE7FILENAME, imageData.scene7FileName);
    if (imageData.cropRect && imageData.cropRect.width > 0 && imageData.cropRect.height > 0) {
      const cropRect = adjustCropSize(
        { width: imageData.originalWidth, height: imageData.originalHeight },
        imageData.finalCropRect
      );
      url += '&crop=' + cropRect.x + ',' + cropRect.y + ',' + cropRect.width + ',' + cropRect.height;
    }

    if (imageData.direction) {
      url += '&rotate=' + imageData.direction;
    }
  }
  // limit the resource image size
  if (imageData.originalWidth > PREVIEW_MAX_DIMENSION || imageData.originalHeight > PREVIEW_MAX_DIMENSION)
    url += '&wid=' + previewDimension.width;

  return url;
}

export function addUrlParamForLogoRotate(originImageUrl, imageData, width) {
  let url = originImageUrl;

  if (imageData.cropRect && imageData.cropRect.width > 0 && imageData.cropRect.height > 0) {
    const imageSize = { width: imageData.originalWidth, height: imageData.originalHeight };
    const cropRect = adjustCropSize(imageSize, imageData.finalCropRect);
    url += '&crop=' + cropRect.x + ',' + cropRect.y + ',' + cropRect.width + ',' + cropRect.height;
  }

  if (imageData.direction) {
    url += '&rotate=' + imageData.direction;
  }

  url += '&wid=' + width;
  return url;
}

// Project 14904: images uploaded to cloud are auto-resized to be no more than 2000*2000(done by back-end), so the crop params need to be adjusted
function adjustCropSize(originalSize, cropRect) {
  if (originalSize.width <= MAX_CLOUD_IMAGE_SIZE && originalSize.height <= MAX_CLOUD_IMAGE_SIZE) {
    return cropRect;
  }

  const scale = getImageScale(originalSize);

  return {
    x: cropRect.x / scale,
    y: cropRect.y / scale,
    width: cropRect.width / scale,
    height: cropRect.height / scale,
  };
}

function getImageScale(originalSize) {
  if (originalSize.width <= MAX_CLOUD_IMAGE_SIZE && originalSize.height <= MAX_CLOUD_IMAGE_SIZE) return 1;

  const newSize = adjustImageSizeToFitContainer(originalSize, {
    width: MAX_CLOUD_IMAGE_SIZE,
    height: MAX_CLOUD_IMAGE_SIZE,
  });
  return originalSize.width / newSize.width;
}

const adjustImageSizeToFitContainer = (imageSize, containerSize) => {
  if (typeof imageSize.height === 'undefined' || isNaN(imageSize.height) || imageSize.height === 0)
    return containerSize;

  let newWidth = 0.0;
  let newHeight = 0.0;
  const ratio = imageSize.width / imageSize.height;
  if (containerSize.width > containerSize.height) {
    newHeight = containerSize.height;
    newWidth = containerSize.height * ratio;
    if (newWidth > containerSize.width) {
      newWidth = containerSize.width;
      newHeight = containerSize.width / ratio;
    }
  } else {
    newWidth = containerSize.width;
    newHeight = containerSize.width / ratio;
    if (newHeight > containerSize.height) {
      newHeight = containerSize.height;
      newWidth = containerSize.height * ratio;
    }
  }

  return { width: Math.round(newWidth), height: Math.round(newHeight) };
};

const ITEM_URL = '//images.promotionalstore.com/is/image/PromotionalStore/i?src=is{PromotionalStore/product_{ItemId}}';
export function getItemUrl(itemId) {
  let baseUrl = ITEM_URL.replace(PLACEHOLDER_ITEMID, itemId);
  return `${baseUrl}&$ProductDetail_D$`;
}
export function getGeneralItemUrl(itemId) {
  let baseUrl = ITEM_URL.replace(PLACEHOLDER_ITEMID, itemId);
  return `${baseUrl}&$General_T$`;
}

export function getStockImageUrl(itemId) {
  let url = ITEM_URL.replace(PLACEHOLDER_ITEMID, itemId);
  return url;
}

export function getColorizedStockImageUrl(itemId, codeValue) {
  let url = COLORIZED_STOCKIMAGE_URL.replace(PLACEHOLDER_ITEMID, itemId).replace(PLACEHOLDER_CODEVALUE, codeValue);
  return url;
}

export function getTexturizedStockImageUrl(textureImageName) {
  let url = TEXTURIZED_STOCKIMAGE_URL.replace(TEXTURE_IMAGE, textureImageName);
  return url;
}

export function checkStockImageExistence(itemId, callback) {
  let url = 'https:' + ITEM_URL.replace(PLACEHOLDER_ITEMID, itemId);
  const img = new Image();
  img.onload = () => {
    callback(true);
  };
  img.onerror = () => {
    callback(false);
  };
  img.src = url;
  // get(url, {}, {}, true).then(function (response) {
  //   callback(true);
  // }).catch(function (error) {
  //   callback(false);
  // });
}

export function getImageDimension(studioItemType, fileName, callback) {
  if (studioItemType === studioItemTypeEnum.nonDigital) return;
  let dimension = { width: 0, height: 0 };
  get(`/api/v1/ArtDimension?fileName=${fileName}`)
    .then(function (response) {
      if (response.data !== '') {
        let infos = response.data.split(',');
        if (infos.length === 2) {
          dimension.width = parseInt(infos[0]);
          dimension.height = parseInt(infos[1]);
        }
      }
      callback && typeof callback === 'function' && callback(dimension);
    })
    .catch(function (error) {
      callback && typeof callback === 'function' && callback(dimension);
    });
}
const HOTSTAMP_COLORIMAGE_URL =
  '//images.promotionalstore.com/is/image/PromotionalStore/i?src=is{PromotionalStore/hotstamp_{ColorCode}}&rotate=90';
export function getHotStampColorImageUrl(colorCode) {
  let url = HOTSTAMP_COLORIMAGE_URL.replace(PLACEHOLDER_COLORCODE, colorCode);
  return url;
}

const hexColorToRgb = (hex) => {
  let hexColor = hex.toLowerCase();
  // change to six if the number of color value is three
  if (hexColor.length === 4) {
    let colorNew = '#';
    for (let i = 1; i < 4; i += 1) {
      colorNew += hexColor.slice(i, i + 1).concat(hexColor.slice(i, i + 1));
    }
    hexColor = colorNew;
  }
  // change to rgb array
  let colorChange = [];
  for (let i = 1; i < 7; i += 2) {
    colorChange.push(parseInt('0x' + hexColor.slice(i, i + 2)));
  }
  return colorChange; //eg:[255,255,255]
};

const rgbColortoHex = (rgb) => {
  let strHex = '#';
  for (let i = 0; i < rgb.length; i++) {
    let hex = parseInt(rgb[i]).toString(16);
    hex = hex.length === 1 ? '0' + hex : hex;
    strHex += hex;
  }
  return strHex; //eg:#223344
};

export const changeColorBrightness = (colorReference, percent) => {
  const rgbColor = hexColorToRgb(colorReference);
  let correctionFactor = percent / 100;
  let red = rgbColor[0];
  let green = rgbColor[1];
  let blue = rgbColor[2];
  if (correctionFactor < 0) {
    correctionFactor = 1 + correctionFactor;
    red *= correctionFactor;
    green *= correctionFactor;
    blue *= correctionFactor;
  } else {
    red = (255 - red) * correctionFactor + red;
    green = (255 - green) * correctionFactor + green;
    blue = (255 - blue) * correctionFactor + blue;
  }
  return rgbColortoHex([red, green, blue]);
};
export const getLighterColorHexForDebossedFullPreview = (hex) => {
  const rgb = hexColorToRgb(hex);
  const a =
    rgb.filter((c) => c <= 40).length >= 2
      ? 70
      : rgb.every((c) => c <= 130)
      ? 50
      : rgb.every((c) => c > 130 && c <= 200)
      ? 30
      : 10;
  return rgbColortoHex(rgb.map((c) => Math.min(255, c + a))).toUpperCase();
};

export const strictEncode = (str) => {
  return encodeURIComponent(str).replace(/[()!]/g, (ch) => '%' + ch.charCodeAt(0).toString(16).toUpperCase());
};
export const getStockImageUrlByExistenceMode = (itemId, twinItemId, stockImageTypeDict, bomOption, stockImageExist) => {
  const key = `${bomOption.code}-${bomOption.codeValue}`;
  const stockImageType = stockImageTypeDict[key];

  if (stockImageType === scene7StockImageMode.NotExist) {
    return stockImageExist ? getStockImageUrl(itemId) : '';
  } else if (
    stockImageType === scene7StockImageMode.ItemExist ||
    stockImageType === scene7StockImageMode.TwinItemExist
  ) {
    const _itemId = stockImageType === scene7StockImageMode.ItemExist ? itemId : twinItemId;
    return bomOption.useTexture
      ? getTexturizedStockImageUrl(`texture_${_itemId}_${bomOption.code}_${bomOption.codeValue}`)
      : getColorizedStockImageUrl(_itemId, bomOption.codeValue);
  } else {
    return '';
  }
};

export function logoOnly(canvasSize, imageSize) {
  //LogoOnlyRotate is same as LogoOnly
  const resizedImageSize = adjustImageSizeToFitContainer(imageSize, canvasSize);
  return resizedImageSize;
}

export function logoOnlyCrop(canvasSize, imageSize, cropRect) {
  const cropCenterPoint = getCropCenterPoint(canvasSize, imageSize, cropRect);
  const offset = { x: -cropCenterPoint.x, y: -cropCenterPoint.y };
  const resizedImageSize = adjustImageSizeToFitContainer(
    { width: cropRect.width, height: cropRect.height },
    canvasSize
  );
  return {
    position: offset,
    size: resizedImageSize,
  };
}

export function logoOnlyCropRotate(canvasSize, imageSize, cropRect, degree) {
  const cropCenterPoint = getCropCenterPoint(canvasSize, imageSize, cropRect);
  const rotatedCenterPoint = rotatePoint(degree, cropCenterPoint);
  const offset = { x: -rotatedCenterPoint.x, y: -rotatedCenterPoint.y };
  const resizedImageSize = adjustImageSizeToFitContainer(
    { width: cropRect.width, height: cropRect.height },
    canvasSize
  );
  return {
    position: offset,
    size: resizedImageSize,
  };
}

export function backgroundCrop(canvasSize, imageSize, cropRect) {
  const cropCenterPoint = getCropCenterPoint(canvasSize, imageSize, cropRect);
  const offset = { x: -cropCenterPoint.x, y: -cropCenterPoint.y };
  const resizedImageSize = adjustImageSizeToFitContainer(
    { width: cropRect.width, height: cropRect.height },
    canvasSize
  );
  return {
    position: offset,
    size: resizedImageSize,
  };
}

export function backgroundRotate(canvasSize, imageSize, degree) {
  const { newImageSize } = rotate(canvasSize, imageSize, degree);
  return newImageSize;
}

export function backgroundCropRotate(canvasSize, imageSize, cropRect, degree) {
  const result = cropAndRotate(canvasSize, imageSize, cropRect, degree);
  return {
    position: { x: result.x, y: result.y },
    size: { width: result.width, height: result.height },
  };
}

export function logoTextPosition(canvasSize, logoArea, textArea, logoLayout = logoLayoutOption.LogoAboveText) {
  var logoCenterPoint = {
    x: logoArea.width / 2 - canvasSize.width / 2,
    y: logoArea.height / 2 - canvasSize.height / 2,
  };
  var interval = {
    width: canvasSize.width - logoArea.width - textArea.width,
    height: canvasSize.height - logoArea.height - textArea.height,
  };
  var textCenterPoint = {
    x: textArea.width / 2 + logoArea.width + interval.width - canvasSize.width / 2,
    y: textArea.height / 2 + logoArea.height + interval.height - canvasSize.height / 2,
  };

  if (logoLayout === logoLayoutOption.LogoBelowText || logoLayout === logoLayoutOption.LogoRightOfText) {
    logoCenterPoint.x = -logoCenterPoint.x;
    logoCenterPoint.y = -logoCenterPoint.y;
    textCenterPoint.x = -textCenterPoint.x;
    textCenterPoint.y = -textCenterPoint.y;
  }

  return { logoPosition: logoCenterPoint, textPosition: textCenterPoint };
}

export function logoTextRotate(
  canvasSize,
  logoArea,
  textArea,
  imageSize,
  degree,
  logoLayout = logoLayoutOption.LogoAboveText
) {
  var result = logoTextPosition(canvasSize, logoArea, textArea, logoLayout);
  var newImageSize = backgroundRotate(logoArea, imageSize, degree);

  return {
    logoSize: newImageSize,
    logoPosition: result.logoPosition,
    textPosition: result.textPosition,
    textSize: textArea,
    logoSizeAvailable: true,
    logoPositionAvailable: true,
    textSizeAvailable: true,
    textPositionAvailable: true,
  };
}

export function LogoTextCrop(
  canvasSize,
  logoArea,
  textArea,
  imageSize,
  cropRect,
  logoLayout = logoLayoutOption.LogoAboveText
) {
  var result1 = logoTextPosition(canvasSize, logoArea, textArea, logoLayout);
  var result2 = crop(logoArea, imageSize, cropRect);
  var logoPosition = { x: result2.x, y: result2.y };

  if (logoLayout === logoLayoutOption.LogoAboveText || logoLayout === logoLayoutOption.LogoBelowText) {
    logoPosition.y += result1.logoPosition.y;
  } else {
    logoPosition.x += result1.logoPosition.x;
    // special - add %1 to text width for Horizon layout in order not to wrap
    textArea.width *= 1.01;
  }

  return {
    logoSize: { width: result2.width, height: result2.height },
    logoPosition: logoPosition,
    textPosition: result1.textPosition,
    textSize: textArea,
    logoSizeAvailable: true,
    logoPositionAvailable: true,
    textSizeAvailable: true,
    textPositionAvailable: true,
  };
}

export function logoTextCropRotate(
  canvasSize,
  logoArea,
  textArea,
  imageSize,
  cropRect,
  degree,
  logoLayout = logoLayoutOption.LogoAboveText
) {
  var result1 = logoTextPosition(canvasSize, logoArea, textArea, logoLayout);
  var result2 = cropAndRotate(logoArea, imageSize, cropRect, degree);
  var logoPosition = { x: result2.x, y: result2.y };

  if (logoLayout === logoLayoutOption.LogoAboveText || logoLayout === logoLayoutOption.LogoBelowText) {
    logoPosition.y += result1.logoPosition.y;
  } else {
    logoPosition.x += result1.logoPosition.x;
    // special - add %1 to text width for Horizon layout in order not to wrap
    textArea.width *= 1.01;
  }

  return {
    logoSize: { width: result2.width, height: result2.height },
    logoPosition: logoPosition,
    textPosition: result1.textPosition,
    textSize: textArea,
    logoSizeAvailable: true,
    logoPositionAvailable: true,
    textSizeAvailable: true,
    textPositionAvailable: true,
  };
}

function crop(canvasSize, imageSize, cropRect) {
  // scale for crop rect to canvas rect
  var scale = Math.min(canvasSize.width / cropRect.width, canvasSize.height / cropRect.height);

  // get center point of crop area
  var cropRectLeftTop = { x: cropRect.x - imageSize.width / 2, y: cropRect.y - imageSize.height / 2 };
  var centerPoint = { x: cropRectLeftTop.x + cropRect.width / 2, y: cropRectLeftTop.y + cropRect.height / 2 };
  centerPoint.x = centerPoint.x * scale;
  centerPoint.y = centerPoint.y * scale;

  // get new image size
  var newSize = { width: cropRect.width * scale, height: cropRect.height * scale };

  return { x: -centerPoint.x, y: -centerPoint.y, width: newSize.width, height: newSize.height };
}

function getCropCenterPoint(canvasSize, imageSize, cropRect) {
  const cropCenterPoint = {
    x: cropRect.x + cropRect.width / 2 - imageSize.width / 2,
    y: cropRect.y + cropRect.height / 2 - imageSize.height / 2,
  };
  const scale = Math.min(canvasSize.width / cropRect.width, canvasSize.height / cropRect.height);
  cropCenterPoint.x *= scale;
  cropCenterPoint.y *= scale;
  return cropCenterPoint;
}

function rotatePoint(degree, p) {
  const rad = (degree / 180) * Math.PI;
  const newX = p.x * Math.cos(rad) - p.y * Math.sin(rad);
  const newY = p.y * Math.cos(rad) + p.x * Math.sin(rad);
  return { x: newX, y: newY };
}

function rotate(canvasSize, imageSize, degree) {
  // rotate the image rect
  const p1 = { x: -imageSize.width / 2, y: -imageSize.height / 2 };
  const p2 = { x: imageSize.width / 2, y: -imageSize.height / 2 };
  const p3 = { x: imageSize.width / 2, y: imageSize.height / 2 };
  const p4 = { x: -imageSize.width / 2, y: imageSize.height / 2 };
  const result1 = rotateRect(degree, p1, p2, p3, p4);
  const diagonal1 = [result1[0], result1[2]];
  const diagonal2 = [result1[1], result1[3]];

  // get top/left line
  const c1 = { x: -canvasSize.width / 2, y: -canvasSize.height / 2 };
  const c2 = { x: canvasSize.width / 2, y: -canvasSize.height / 2 };
  //const c3 = { x: canvasSize.width / 2, y: canvasSize.height / 2 };
  const c4 = { x: -canvasSize.width / 2, y: canvasSize.height / 2 };
  const topLine = [c1, c2];
  const leftLine = [c1, c4];

  //diagonal resize scale
  const intersect11 = lineIntersection(diagonal1[0], diagonal1[1], topLine[0], topLine[1]);
  const scale11 = getScale(diagonal1[0], intersect11);
  const intersect12 = lineIntersection(diagonal1[0], diagonal1[1], leftLine[0], leftLine[1]);
  const scale12 = getScale(diagonal1[0], intersect12);
  const scale1 = Math.min(scale11, scale12);

  const intersect21 = lineIntersection(diagonal2[0], diagonal2[1], topLine[0], topLine[1]);
  const scale21 = getScale(diagonal2[0], intersect21);
  const intersect22 = lineIntersection(diagonal2[0], diagonal2[1], leftLine[0], leftLine[1]);
  const scale22 = getScale(diagonal2[0], intersect22);
  const scale2 = Math.min(scale21, scale22);

  const scale = Math.min(scale1, scale2);

  const newImageSize = { width: imageSize.width * scale, height: imageSize.height * scale };
  return { newImageSize, scale };
}

function rotateRect(degree, p1, p2, p3, p4) {
  const list1 = [p1, p2, p3, p4];
  const list2 = [];
  list1.forEach((p, index) => {
    list2[index] = rotatePoint(degree, p);
  });
  return list2;
}

function lineIntersection(p11, p12, p21, p22) {
  const x1 = p11.x - p12.x;
  const x2 = p21.x - p22.x;
  const y1 = p11.y - p12.y;
  const y2 = p21.y - p22.y;
  const d1 = det(p11.x, p11.y, p12.x, p12.y);
  const d2 = det(p21.x, p21.y, p22.x, p22.y);
  const x = det(d1, x1, d2, x2);
  const y = det(d1, y1, d2, y2);
  const d = det(x1, y1, x2, y2);
  if (d === 0) return {};
  return { x: x / d, y: y / d };
}

function det(a, b, c, d) {
  return a * d - b * c;
}

function getScale(diagonalPoint, intersect) {
  //center point of diagonal is (0,0)
  const d1 = Math.sqrt(Math.pow(diagonalPoint.x, 2) + Math.pow(diagonalPoint.y, 2));
  const d2 = Math.sqrt(Math.pow(intersect.x, 2) + Math.pow(intersect.y, 2));
  const diagonalLength = d1 * 2;
  if (d1 > d2) {
    // reduce
    return (diagonalLength - (d1 - d2) * 2) / diagonalLength;
  } else {
    // increase
    return (diagonalLength + (d2 - d1) * 2) / diagonalLength;
  }
}

function cropAndRotate(canvasSize, imageSize, cropRect, degree) {
  // firstly, get the diagonal scale of crop rect
  const cropSize = { width: cropRect.width, height: cropRect.height };
  const { scale } = rotate(canvasSize, cropSize, degree);

  // second, get center point of crop area
  const cropRectLeftTop = { x: cropRect.x - imageSize.width / 2, y: cropRect.y - imageSize.height / 2 };
  const centerPoint = { x: cropRectLeftTop.x + cropRect.width / 2, y: cropRectLeftTop.y + cropRect.height / 2 };
  centerPoint.x *= scale;
  centerPoint.y *= scale;

  //rotate the center point
  const offset = rotatePoint(degree, centerPoint);

  // get new image size
  const newSize = { width: cropSize.width * scale, height: cropSize.height * scale };

  return { x: -offset.x, y: -offset.y, width: newSize.width, height: newSize.height };
}

export const addColorizeParamToUrl = (url, studioItemType, maxColorCount, logoColors, isHotStamped, processType) => {
  if (maxColorCount === 1) {
    const colorReference = logoColors && logoColors[0] && logoColors[0].colorReference;
    if (colorReference && !isHotStamped)
      url += '&op_contrast=-100&op_brightness=-100&op_colorize=' + colorReference.replace('#', '');
    if (processType === ProcessTypes.Deboss) url += '&op_contrast=-100&op_brightness=-100&op_colorize=000000';
  }

  return url;
};

export const getHotStampedScene7Url = (image) => {
  let hotstampedSrc = `PromotionalStore/hotstamp_${image.colors[0].colorId}?wid=${image.originalWidth}&hei=${image.originalHeight}&fit=stretch,1`;
  let maskSrc = `${
    image.type === userImageType.SavedArt ? image.scene7FileName : `PromotionalStore/${image.scene7FileName}`
  }?wid=${image.originalWidth}&hei=${image.originalHeight}`;
  if (image.type === userImageType.UploadLogo) {
    hotstampedSrc = `PromotionalStore/hotstamp_${image.colors[0].colorId}?wid=${image.originalWidth}&hei=${image.originalHeight}&fit=stretch,1`;
    maskSrc = `${image.scene7FileName}?size=${image.originalWidth},${image.originalHeight}`;
  }
  const url = SCENE7_TEMPLATE_BASIC_URL_HOTSTAMPED.replace(PLACEHOLDER_HOTSTAMPED_SRC, hotstampedSrc).replace(
    PLACEHOLDER_MASK_SRC,
    maskSrc
  );
  return url;
};

export const addUrlParamForHotStamp = (url, image, containerSize) => {
  const { pos, size, cropRect } = getUrlBase({ image, containerSize, isBackground: false });
  url += '&size=' + Math.round(size.width) + ',' + Math.round(size.height);
  if (pos) url += '&pos=' + Math.round(pos.x) + ',' + Math.round(pos.y);
  url += '&crop=' + cropRect.x + ',' + cropRect.y + ',' + cropRect.width + ',' + cropRect.height;
  url += '&rotate=' + image.direction;
  return url;
};
